// ----------------------------------------
// ドロップダウンメニュー
// ----------------------------------------
$(function () {
  $('.js-dropdown-point').on('mouseover', function () {
    $(this).find('.js-dropdown-content').addClass('is-open');
  }).on('mouseout', function () {
    $(this).find('.js-dropdown-content').removeClass('is-open');
  });
});
